
const PlanosDescricaoContent = (props: any) => {

    function renderObjectBody(data: any) {
        return { __html: data }
    }

    return (
        <div className="row justify-content-center">

            {props.items?.filter((i: { Identificador: any; }) => i.Identificador === props.page).map((item:
                { Corpo: any; }, index: number) => (

                <div className="col-lg-10" key={index}>
                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Corpo)} />
                </div>

            ))}
        </div>
    )
};
export default PlanosDescricaoContent;
